<!-- loader.component.html -->
<div class="loader-container" [ngClass]="overlayState ? '' : 'loading-index'" *ngIf="loading || overlayState">
  <img id="loaderImg" *ngIf="loading" class="loader-img" src="assets/images/loader.svg" alt="loading...">
</div>
